import { type GetStaticPaths, type GetStaticProps } from 'next';
import { getCourtPageUrl } from 'constants/pages';
import { getImageUrl } from 'services/client/cloudflare/getImageUrl';
import { getAllGroupPaths } from 'services/server/graphql/queries/getAllGroupPaths';
import { getGroupPageContentByGroupSlug } from 'services/server/graphql/queries/getGroupPageContentByGroupSlug';
import { combineJsonLdSchemas } from 'utils/shared/json-ld/combineJsonLdSchemas';
import { generatePlaceJsonLd } from 'utils/shared/json-ld/place';
import { generateSportsActivityLocationJsonLd } from 'utils/shared/json-ld/sports';
import { generateSportsEventJsonLd } from 'utils/shared/json-ld/sportsEvent';
import GroupsPage, { GroupPageProps } from 'screens/GroupsPage';

const REVALIDATE_IN_SECONDS = 60 * 60 * 1;

const IS_ALL_AS_ISR = true;

export const getStaticProps: GetStaticProps<GroupPageProps, { groupSlug: string }> = async ({
  params,
}) => {
  const groupSlug = params?.groupSlug;
  const resp = await getGroupPageContentByGroupSlug({
    slug: groupSlug as string,
  });

  const group = resp?.groups?.[0];

  if (!group || !group?.id || !group.title) {
    return {
      notFound: true,
      revalidate: REVALIDATE_IN_SECONDS,
    };
  }

  // const groupJsonLd = generatePlaceJsonLd({
  //   name: group?.title,
  //   geo: {
  //     latitude: group?.latitude,
  //     longitude: group?.longitude,
  //   },
  //   containsPlace: group?.venues?.map((venue) =>
  //     generateSportsActivityLocationJsonLd({
  //       name: venue?.venue?.title,
  //       address: venue?.venue?.addressString,
  //       image: venue?.venue?.images?.[0]?.url || '',
  //       url: `${process.env.APP_URL}${getCourtPageUrl(venue?.venue?.slug)}`,
  //     }),
  //   ),
  // });

  // const groupSportEventJsonLd = group?.events?.map((event) => {
  //   const addressFromVenue = event?.addressString || '';
  //   const addressFromCity =
  //     event?.city && event.city?.name && event.city?.countrySubdivision?.name
  //       ? `${event.city.name}, ${event.city.countrySubdivision.name}`
  //       : '';
  //   return generateSportsEventJsonLd({
  //     name: event?.title || '',
  //     sport: event?.sport,
  //     description: event?.description || '',
  //     startDate: event?.startDateTime || '',
  //     endDate: event?.endDateTime || '',
  //     image: event?.coverImageUrl
  //       ? getImageUrl({
  //           url: event.coverImageUrl,
  //           path: event.coverImagePath || '',
  //         })
  //       : undefined,
  //     location: {
  //       name: event?.venue?.title || '',
  //       url: event?.venue?.slug ? `${process.env.APP_URL}${getCourtPageUrl(event.venue.slug)}` : '',
  //       address:
  //         event.addressString || addressFromVenue || addressFromCity || event.displayLocation || '',
  //       geo: {
  //         latitude: event?.geometry?.coordinates[1] || '',
  //         longitude: event?.geometry?.coordinates[0] || '',
  //       },
  //     },
  //   });
  // });
  // const breadcrumbs = generateBreadcrumbListJsonLd({
  //   items: generateBreadcrumbs({
  //     cityName: city?.name || '',
  //     citySlug: city?.slug || '',
  //     regionName: city?.countrySubdivision?.name || '',
  //     regionSlug: city?.countrySubdivision?.slug || '',
  //     countryId: city?.countrySubdivision?.country?.id || '',
  //     countryName: city?.countrySubdivision?.country?.name || '',
  //     countrySlug: city?.countrySubdivision?.country?.slug || '',
  //   }).jsonLd,
  // });

  // const combinedSchemas = combineJsonLdSchemas([groupSportEventJsonLd, groupJsonLd]);

  return {
    props: {
      tournaments: group?.events,
      group,
      jsonLd: null,
    },
    revalidate: REVALIDATE_IN_SECONDS,
  };
};

export const getStaticPaths: GetStaticPaths = async () => {
  if (IS_ALL_AS_ISR) {
    return {
      paths: [],
      fallback: true,
    };
  }
  const groups = await getAllGroupPaths();

  const paths = groups.groups.map((group) => {
    return {
      params: {
        groupSlug: group.slug,
      },
    };
  });
  return {
    paths,
    fallback: true,
  };
};

export default GroupsPage;
